import React from 'react';
import { useSelector } from 'react-redux';
import { Tabs } from 'antd';
import {
  // BarChartOutlined,
  ImportOutlined,
  ScissorOutlined,
  PlusOutlined,
  ForwardOutlined,
  GiftOutlined,
  DollarOutlined,
} from '@ant-design/icons';

import Layout from '../Layout/index';
import ErrorBoundary from '../../components/Utils/ErrorBoundary';
import Advances from './Advances';
import Allowances from './Allowances';
import Deductions from './Deductions';
import IncentiveImports from './IncentiveImports';
import Incentives from './Incentives';
import Conveyances from './Conveyances';
import './style.css';

const { TabPane } = Tabs;

const Expense = ({ match, history }) => {
  const { user } = useSelector((state) => state.login);
  return (
    <Layout title="Expense">
      <Tabs
        defaultActiveKey={
          typeof match.params !== 'undefined' &&
          typeof match.params.tab !== 'undefined'
            ? match.params.tab
            : 'incentive-imports'
        }
        type="editable-card"
        size="medium"
        key={
          typeof match.params !== 'undefined' &&
          typeof match.params.tab !== 'undefined'
            ? match.params.tab
            : 'incentive-imports'
        }
        className="expenseTab"
        hideAdd
        onChange={(key) => {
          history.push(`/expense/${key}`);
        }}
      >
        {user && user.ability.toListIncentives && (
          <TabPane
            tab={
              <span>
                <ImportOutlined />
                Incentive Imports
              </span>
            }
            key="incentive-imports"
            closable={false}
          >
            <ErrorBoundary>
              <IncentiveImports
                gridId="incentive-imports"
                incentivesGridId="incentives"
              />
            </ErrorBoundary>
          </TabPane>
        )}
        {user && user.ability.toListIncentives && (
          <TabPane
            tab={
              <span>
                <GiftOutlined />
                Incentives
              </span>
            }
            key="incentives"
            closable={false}
          >
            <ErrorBoundary>
              <Incentives gridId="incentives" />
            </ErrorBoundary>
          </TabPane>
        )}
        {user && user.ability.toListConveyances && (
          <TabPane
            tab={
              <span>
                <DollarOutlined />
                Conveyances
              </span>
            }
            key="conveyances"
            closable={false}
          >
            <ErrorBoundary>
              <Conveyances gridId="conveyances" />
            </ErrorBoundary>
          </TabPane>
        )}
        {user && user.ability.toListAllowances && (
          <TabPane
            tab={
              <span>
                <PlusOutlined />
                Allowances
              </span>
            }
            key="allowances"
            closable={false}
          >
            <ErrorBoundary>
              <Allowances gridId="allowances" />
            </ErrorBoundary>
          </TabPane>
        )}
        {user && user.ability.toListDeductions && (
          <TabPane
            tab={
              <span>
                <ScissorOutlined />
                Deductions
              </span>
            }
            key="deductions"
            closable={false}
          >
            <ErrorBoundary>
              <Deductions gridId="deductions" />
            </ErrorBoundary>
          </TabPane>
        )}
        {/* {user && user.ability.toListAdvances && (
          <TabPane
            tab={
              <span>
                <ForwardOutlined />
                Advances
              </span>
            }
            key="advance"
            closable={false}
          >
            <ErrorBoundary>
              <Advances gridId="advance" />
            </ErrorBoundary>
          </TabPane>
        )} */}
        {/* {user && user.ability.toAccessReports && (
          <TabPane
            tab={
              <span>
                <BarChartOutlined />
                Reports
              </span>
            }
            key="reports"
            closable={false}
          >
            <ErrorBoundary>
              <Reports match={match} history={history} />
            </ErrorBoundary>
          </TabPane>
        )} */}
      </Tabs>
    </Layout>
  );
};

export default Expense;
